<div class="modal-header modelHeader text-center">
  <div class="tick" *ngIf="IsfromPlaceOffer==true"><span class="icon-tick2 icon"></span></div>
  <h4 class="modal-title pull-left margin-bottom-15" *ngIf="IsfromPlaceOffer==true">Offer submitted successfully!</h4>
  <h6 style="color:white !important;" *ngIf="IsfromPlaceOffer==true" class="margin-bottom-10">B+E Broker will get in touch with you soon. Please tell us more about the acquiring entity.</h6>
  <h4 class="modal-title pull-left" *ngIf="IsfromPlaceOffer==false">Buyer Questionnaire {{attendedCount}} / 34</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="modalBuyerRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="d-flex section-p seller-p-top main-body main-section">
    <div class="container-p" style="flex-wrap:wrap">
      <div class="FirstDiv" *ngIf="activeDiv==1">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">1. Describe the entity that would be acquiring this asset.</label>
              <p>
                a. Inception Date
              </p>
              <p>b. Principals </p>
              <p>c. Structure </p>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="250"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.EntityAcquiringAsset" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">2. Describe your current portfolio.</label>
              <p>
                a. Property Type(s)
              </p>
              <p>b. Location/SF </p>
              <p>c. Tenant Base </p>
              <p>d. Occupancy % </p>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="250"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.CurrentPortfolio" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">3. May we speak directly to recent seller(s) about their LOI-to-contract-to-closing experience?</label>
              <p>a. Contact information and brief description of the acquisition</p>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="250"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.SpeakToSeller" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">4. Why is this asset of interest?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="250"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.AssetofInterest" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">5. Based upon your review, what additional information do you require to satisfy your due diligence?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="250"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.AdditionalInformation" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="SecondDiv" *ngIf="activeDiv==2">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">6. What are the names of the key team members responsible for the underwriting and due diligence of this acquisition?  What are their roles?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="150"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.KeyTeamMember" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">7. What third party firms will you use to complete your due diligence and what is their role?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="150"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.ThirdPartyFirms" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">8. Can you provide your current schedule of allocations per property based upon your current offer?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="100"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.CurrentScheduleAllocation" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">9. Do you handle property management in-house or do you have a third party management company?  If so, who are they?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="100"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.ThirdPartyPropertyManagement" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">10. What is the source of equity that will be used to close?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="50"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.SouceOfEquity" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="ThirdDiv" *ngIf="activeDiv==3">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">11. How much equity is currently on hand and available (unencumbered)?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="50"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.EquityOnHand" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">12. Where are these funds being held and how can we confirm the current balance/availability?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="100"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.ConfirmCurrentAvailibity" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">13. Is debt required to close, will it be a contingency to your contract?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="100"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.IsDebtRequired" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">14. If so, what are your debt assumptions?</label>
              <p>a. Source of debt (bank, insurance co, conduit)?</p>
              <p>b. LTV or LTC valuation?</p>
              <p>c. Leasehold or fee simple valuation?</p>
              <p>d. Interest rate?</p>
              <p>e. Amortization schedule?</p>
              <p>f. Term?</p>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="250"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.DebtAssumptions" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="FouthDiv" *ngIf="activeDiv==4">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">15. What lenders have you spoken to about this acquisition?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="150"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.Lenders" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">16. What have they told you?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="150"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.HaveTheyToldyou" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">17. Have you picked a lender?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="50"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.PickedLenderDescription" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">18. What closings have you completed with your chosen lender?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="150"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.LenderClosing" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">19. How long has your lender had the OM and DDL info?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="100"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.LenderOmDdInfo" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="FifthDiv" *ngIf="activeDiv==5">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">20. How much effort has your lender put into reviewing the OM and DDL?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="100"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.LenderEffort" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">21. What underwriting concerns is your lender expressing?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="150"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.UnderWritingConerns" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">22. Will your lender underwrite to the contract rents or look to rent comps as their basis for valuation?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="150"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.LenderUnderWriteContract" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">23. When will your lender be in a position to issue a commitment letter?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="100"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.LenderPositiontime" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">24. What are your lender’s time frames for next steps and what is their internal approval process required to close?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="250"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.LenderTimeFrame" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="SixthDiv" *ngIf="activeDiv==6">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">25. If your lender modifies their debt and/or underwriting assumptions during escrow, how will you handle that?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="250"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.LenderDebtHandle" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">26. If your lender modifies their debt assumptions during escrow, how far can they pull back on promised LTC funding and pricing before your equity and return equation says “can’t do it”?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="150"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.LTCFunding" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">
                27. May we speak to your lender?
                What is their contact information?
              </label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="150"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.LenderContactInfo" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">28. Do you have a back-up lender?  Who?  Where are they in their approval process? What is required to keep them on pace with the closing schedule?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="250"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.BackupLenderProcess" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row  margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">29. Please explain your internal approval process and what individuals (by name and title) are required to approve the following steps:</label>
              <p>a. Execution of the LOI</p>
              <p>b. Execution of the Contract</p>
              <p>c. Authorization to proceed beyond the Feasibility Period (i.e. Put the earnest money at risk)</p>
              <p>d. Authorization to fund the close</p>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="250"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.InternalApprovalProcess" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>

            </div>
          </div>
        </div>
      </div>

      <div class="SeventhDiv" *ngIf="activeDiv==7">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">30. Define your underwriting concerns and impediments to close.</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="250"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.ConcernsToClose" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">31. Has your firm or any affiliate defaulted on debt in the last 5 years?  If so, explain.</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="150"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.DebtDescription" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">32. Has your firm or any affiliate declared bankruptcy in the last 5 years?  If so, explain.</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="150"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.BankruptucyDescription" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">33. Will you be seeking 1031 treatment in the closing?  If so, please describe the status of your exchange, has your primary sale closed and what is your outside reinvestment closing date?  Is this acquisition an exclusive designation or do you have other properties identified?  What is the name and contact information for your exchange company?</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="250"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.ExchangeDetails" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
        <div class="row margin-top-15">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group">
              <label class="form-label">34. Please provide reference contact information.</label>
              <textarea class="form-control property-description interestcriteriadisable" maxlength="150"
                        rows="3" [(ngModel)]="BuyerQuestionsModel.ReferenceInformation" (change)="getcount();" [attr.disabled]="IsHavePermission!=1?'true':null"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-btn-wrapper">
        <div class="bottom-btn margin-top-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="btn-left d-flex">
            <button class="btn-lg btn-border btn adduserbtn" *ngIf="activeDiv!=1" (click)="GetNextQuestions('Back');"> Back</button>
            <button class="btn-lg btn-border btn adduserbtn" *ngIf="IsHaveRemainder==1&&haveaccess==true&&(attendedCount!=34||BuyerQuestionsModel.IsDraft==true)" (click)="SendRemainder();"> Send Reminder</button>
            <button class="btn-lg btn-border btn adduserbtn" *ngIf="IsHavePermission==1" (click)="Save('SaveLater')"> Save as Draft</button>
          </div>
          <div class="btn-rt d-flex">
            <button class="btn btn-border btn-lg" *ngIf="IsHavePermission==1" (click)="OnCancel();"> Cancel</button>
            <button class="btn-lg btn-border btn adduserbtn" *ngIf="activeDiv<7" (click)="GetNextQuestions('Next');"> Next</button>
            <button class="btn btn-success btn-lg btn-submit" *ngIf="IsHavePermission==1" (click)="Save('Submit')"> Submit</button>
          </div>
         </div>
      </div>
     
    </div>
  </div>
</div>

